import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';
import UpdateNoticeModal from './UpdateNoticeModal';

export default function Layout() {
  return (
    <div className="min-h-screen bg-background-50 max-w-lg mx-auto relative">
      <main className="pb-[calc(88px+env(safe-area-inset-bottom))]">
        <Outlet />
      </main>
      <BottomNav />
      <UpdateNoticeModal />
    </div>
  );
}
